<script setup lang="ts">
import Quote from "@/assets/icons/quote.svg?component";
import MarkDownIt from "markdown-it";

const props = defineProps<{
  quote: string;
  author?: string;
  quoteSize?: string;
  authorSize?: string;
}>();

const md = new MarkDownIt({ html: true });
const html = ref(md.render(props.quote));

const quoteEl = ref<null | HTMLElement>(null);

onMounted(() => {
  if (quoteEl.value) quoteEl.value.innerHTML = html.value;
});
</script>

<template>
  <div class="base-quote flex flex-col border-l-2 border-l-light-gray pl-3">
    <Quote class="text-integer-light-green" />
    <p
      ref="quoteEl"
      class="mt-3"
      :class="`text-${props.quoteSize ? props.quoteSize : 'h3'}`"
    />
    <p
      v-if="author"
      class="mt-3"
      :class="`text-${props.authorSize ? props.authorSize : 'xs'}`"
    >
      {{ author }}
    </p>
  </div>
</template>
